import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { AppointmentService } from 'services/appointments';
import { useEnterpriseId } from 'stores/user';
import { type AppointmentWithDetails } from 'types/appointments';

const DEFAULT_RECENT_SESSIONS_LIMIT = 5;

export const useFetchRecentSessions = (
  limit: number = DEFAULT_RECENT_SESSIONS_LIMIT
): UseQueryResult<AppointmentWithDetails[]> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_APPOINTMENTS, enterpriseId, limit],
    queryFn: async (): Promise<AppointmentWithDetails[]> => {
      const { data: appointments } = await AppointmentService.getEnterpriseAppointments(
        enterpriseId,
        { limit }
      );

      return Promise.all(
        appointments.map(async appointment => {
          const { data: patient } = await PatientService.getPatient(appointment.patientId);
          const { psychologist, ...rest } = appointment;
          void psychologist;

          return {
            ...rest,
            patient: {
              firstName: patient.firstName,
              surname: patient.surname,
            },
          };
        })
      );
    },
    enabled: !!enterpriseId,
  });
};
